import { JSX, useState, useEffect, useRef } from 'react';
import { NoteProps } from '../note/note';
import WindowBar from '../common/windowBar/windowBar';
import NoteManager from '../todolist/data/noteManager';
import { format } from 'date-fns';
import './noteDropdown.css';
import deleteIcon from '../assets/images/svgs/bin--Streamline-Pixel.svg';

interface NoteDropdownProps {
    selectedNoteOption?: NoteProps,
    setSelectedNote: (option: NoteProps) => void;
    closeWindow: () => void;
};

const NoteDropdown = ({ setSelectedNote, closeWindow }: NoteDropdownProps): JSX.Element => {

    const noteManager = NoteManager.getInstance();
    const [notes, setNotes] = useState<NoteProps[]>([]);

    const handleOptionClick = (option: NoteProps) => {
        setSelectedNote(option);
        closeWindow();
    };

    const refreshTodos = async () => {
        try {
            const fetchedNotes = await noteManager.getNotes(); // Now waits for initialization
            setNotes([...fetchedNotes]);
            console.log(`notes herere ${notes.length}`);
        } catch (error) {
            console.error('Failed to fetch todos:', error);
        } finally {
            //setIsLoading(false);
        }
    };

    useEffect(() => {
        refreshTodos();
    }, []);

    useEffect(() => {
        // Subscribe to updates
        const unsubscribe = noteManager.subscribe(refreshTodos);
        
        // Initial load
        refreshTodos();

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    const formatDate = (date: Date | null): string => {
          return date ? format(date, 'MMM dd') : 'No date set';
        };

    const deleteNote = (note: NoteProps) => {
        noteManager.deleteNote(note._id);
    }

    return (
        <div className='note-dropdown-position'>
            <div className='note-dropdown-container main-pixel-container'>
                <WindowBar title='Notes' IconSrc={null} onClick={closeWindow}/>
                <div className="divider-horizontal"/>
                <div className='note-dropdown-items'>
                    {notes.map((note) => (
                        <div className='note-items-container'>
                            <p 
                                data-text={`${note.title} - ${formatDate(note.date)}`} 
                                onClick={() => handleOptionClick(note)}
                                >
                                {`${note.title} - ${formatDate(note.date)}`}
                            </p>
                            <img src={deleteIcon} onClick={() => deleteNote(note)}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ); 
};

export default NoteDropdown;